/**
 * Console output that is only meant for whoever is running the app from a local
 * dev server. `import.meta.env.DEV` is true for `vite dev` and false in every
 * built bundle, so deployed hosts (dev, staging, production) stay silent and
 * internal details never land in a real user's console.
 *
 * Use it for diagnostic chatter. Anything a user or on-call needs to see should
 * go to Datadog (`~/services/datadog`) instead, not here.
 */
const isLocalDevServer = (): boolean => import.meta.env.DEV;

export const DevLogger = {
  log: (...args: unknown[]): void => {
    if (isLocalDevServer()) console.log(...args);
  },
  warn: (...args: unknown[]): void => {
    if (isLocalDevServer()) console.warn(...args);
  },
  error: (...args: unknown[]): void => {
    if (isLocalDevServer()) console.error(...args);
  },
};
